import React from 'react';
import SectorPage from '../SectorPage/SectorPage';

const EditeursLogiciels = () => {
  const sectorData = {
    title: "Éditeurs de Logiciels",
    subtitle: "Accélérez votre prospection B2B",
    intro: "Les éditeurs SaaS, ERP, CRM ou logiciels métiers font face à des cycles de vente souvent longs. Mettre en avant des démos produits, proposer des contenus techniques par persona, et nourrir le parcours de décision par du lead nurturing est clé pour améliorer la conversion.",
    name: "Éditeurs de Logiciels",
    titleContext: "des éditeurs de logiciels",
    responseContext: "des Éditeurs de Logiciels",
    expertContext: "de l'édition de logiciels"
  };

  return <SectorPage sector={sectorData} />;
};

export default EditeursLogiciels; 